import { render, staticRenderFns } from "./GestionProfil.vue?vue&type=template&id=2f587e3c"
import script from "./GestionProfil.vue?vue&type=script&lang=js"
export * from "./GestionProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports